module.exports = __webpack_public_path__ + "static/media/col-accessories.fb7ceb1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/col-accessories.jpg
// module id = 1116
// module chunks = 33